/** @format */

import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { HmfProgressRingComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@shared/data-access/services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'common-points-progress-ring',
  templateUrl: './points-progress-ring.component.html',
  imports: [HmfProgressRingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PointsProgressRingComponent {
  private readonly store = inject(Store);

  size = input<string>('large');
  pointsTarget = 300;
  loyaltyBalance = toSignal(this.store.selectDefined('LOYALTY_BALANCE'));
  currentPointBalance = computed(() => this.loyaltyBalance()?.currentPointBalance || 0);
}
